import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { registerContextElement } from './app/context-element';

//
// Shoelace: cherry-pick only used components (instead of full package)
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library.js';

// app (core) + shared across modules
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/button-group/button-group.js';
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/menu/menu.js';
import '@shoelace-style/shoelace/dist/components/menu-item/menu-item.js';
import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';

// kng-sgc + kng-prompt
import '@shoelace-style/shoelace/dist/components/copy-button/copy-button.js';
import '@shoelace-style/shoelace/dist/components/divider/divider.js';
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
import '@shoelace-style/shoelace/dist/components/option/option.js';
import '@shoelace-style/shoelace/dist/components/select/select.js';
import '@shoelace-style/shoelace/dist/components/switch/switch.js';
import '@shoelace-style/shoelace/dist/components/tab/tab.js';
import '@shoelace-style/shoelace/dist/components/tab-group/tab-group.js';
import '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js';
import '@shoelace-style/shoelace/dist/components/tag/tag.js';

// kng-rag
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/badge/badge.js';

// kng-rules
import '@shoelace-style/shoelace/dist/components/card/card.js';
import '@shoelace-style/shoelace/dist/components/checkbox/checkbox.js';
import '@shoelace-style/shoelace/dist/components/details/details.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/menu-label/menu-label.js';
import '@shoelace-style/shoelace/dist/components/progress-bar/progress-bar.js';
import '@shoelace-style/shoelace/dist/components/textarea/textarea.js';
import '@shoelace-style/shoelace/dist/components/tree/tree.js';
import '@shoelace-style/shoelace/dist/components/tree-item/tree-item.js';

//
// Shoelace base path (CDN for dev, local for prod)
if (window.location.protocol === 'https:') {
  setBasePath('/');
} else {
  setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.20.0/cdn/');
}

//
// Décoration native du tag <context> (pièces jointes) injecté via innerHTML
registerContextElement();

//
// Bootstrap with optional Sentry (lazy-loaded to reduce initial bundle ~200 kB)
async function bootstrap() {
  const isLocalhost = window.location.hostname === 'localhost';

  if (environment.sentryDsn && !isLocalhost) {
    const Sentry = await import('@sentry/angular');
    Sentry.init({
      dsn: environment.sentryDsn,
      environment: environment.production ? 'production' : 'development',
      sendDefaultPii: true,
      tracesSampleRate: environment.production ? 0.1 : 0,
      integrations: [Sentry.browserTracingIntegration()],
    });
    (window as any).__SENTRY__ = Sentry;
    console.log('🔍 Sentry initialized for environment:', environment.production ? 'production' : 'development');
  } else if (isLocalhost) {
    console.log('🚫 Sentry disabled for localhost development');
  }

  const { AppModule } = await import('./app/app.module');
  await platformBrowserDynamic().bootstrapModule(AppModule);
}

bootstrap().catch(err => {
  console.error(err);
  const Sentry = (window as any).__SENTRY__;
  if (Sentry) {
    Sentry.captureException(err);
  }
});

